import React from "react";
import { CabeceraTable } from "../../../../components/Table/CabeceraTable";
import { TableBase } from "../../../../components/Table/TableBase";
import {
  DetailsListLayoutMode,
  IColumn,
  ICommandBarItemProps,
  Icon,
  TooltipHost,
} from "@fluentui/react";
import { IItemIPERC } from "../../../../Interfaces/IIPERC";
import PersonaTag from "../../../../components/elements/Persona";
import themeBase from "../../../../utils/theme/themeBase";
import Estado from "../../../../components/elements/Estado";
import IconHelper from "../../../../utils/helpers/iconHelper";
import { PanelSupervisorHistorialFiltro } from "./PanelSupervisorHistorialFiltro";
import { useBoolean } from "@fluentui/react-hooks";
import { useIpercPorSupervisor } from "../../../../hooks/Iperc/useIpercPorSupervisor";
import { PanelReporteTelerikSupervisorIperc } from "./PanelReporteTelerikSupervisorIperc";

export const SupervisorHistorialIperc = () => {
  const [
    isOpenPanelFilter,
    { setTrue: openPanelFilter, setFalse: dismissPanelFilter },
  ] = useBoolean(false);
  const [
    isOpenPanelReporteTelerik,
    { setTrue: openPanelReporteTelerik, setFalse: dismissPanelReporteTelerik },
  ] = useBoolean(false);

  const {
    actualizarTabla,
    dataTable,
    _onChangeChoiceGroup,
    _onSelectDate,
    filter,
    _onkeyUpSearchTable,
    filterFechas,
    onChangeComboBox,
    searchBoxRefTable,
    limpiarFiltro,
    isLoading,
  } = useIpercPorSupervisor();

  const _columns: IColumn[] = [
    {
      key: "equipo",
      name: "Equipo",
      fieldName: "equipo",
      minWidth: 110,
      maxWidth: 120,
      isResizable: true,
    },
    {
      key: "actividad",
      name: "Actividad",
      fieldName: "actividad",
      minWidth: 100,
      maxWidth: 150,
      isResizable: true,
    },
    {
      key: "persona",
      name: "Operador",
      fieldName: "persona",
      minWidth: 160,
      maxWidth: 270,
      isResizable: true,
      onRender: (item: IItemIPERC) => (
        <PersonaTag text={item.persona} nroDoi={`DNI : ${item.nroDOI}`} />
      ),
    },
    {
      key: "nroDOI",
      name: "DNI Operador",
      fieldName: "nroDOI",
      minWidth: 70,
      maxWidth: 120,
      isResizable: true,
    },
    {
      key: "supervisor",
      name: "Supervisor",
      fieldName: "supervisor",
      minWidth: 100,
      maxWidth: 200,
      isResizable: true,
      onRender: (item: IItemIPERC) => (
        <PersonaTag
          text={item.supervisor}
          nroDoi={`DNI : ${item.nroDOISupervisor}`}
        />
      ),
    },
    {
      key: "nroDOISupervisor",
      name: "DNI Supervisor",
      fieldName: "nroDOISupervisor",
      minWidth: 70,
      maxWidth: 120,
      isResizable: true,
    },
    {
      key: "fecha",
      name: "Fecha",
      fieldName: "fechaResgitro",
      minWidth: 100,
      maxWidth: 100,
      isResizable: true,
    },
    {
      key: "fechaValidacion",
      name: "Fecha Revision",
      fieldName: "fechaValidacion",
      minWidth: 100,
      maxWidth: 100,
      isResizable: true,
    },
    {
      key: "estado",
      name: "Estado",
      fieldName: "estado",
      minWidth: 80,
      maxWidth: 100,
      isResizable: true,
      onRender: (item: IItemIPERC) => <Estado value={item.estado} />,
    },
    {
      key: "Firma",
      name: "Firmas",
      fieldName: "Firma",
      minWidth: 50,
      maxWidth: 120,
      isResizable: true,
      onRender: (item: IItemIPERC) => (
        <>
          {item.rutaFirma && (
            <TooltipHost content={"Operador"}>
              <Icon
                iconName="PDF"
                className={themeBase.classNamesIcon.iconFont}
                style={{ cursor: "pointer", color: "red" }}
                onClick={(arg) => window.open(item.rutaFirma, "_blank")}
              />
            </TooltipHost>
          )}
          {item.rutasPDF !== undefined && item.rutasPDF.length > 0 && (
            <TooltipHost content={"Supervisor"}>
              <Icon
                iconName="PDF"
                className={themeBase.classNamesIcon.iconFont}
                style={{ cursor: "pointer", color: "red" }}
                onClick={(arg) => window.open(item.rutasPDF[0], "_blank")}
              />
            </TooltipHost>
          )}
        </>
      ),
    },
  ];
  const _CommandLeftItems: ICommandBarItemProps[] = [
    {
      ...IconHelper.ICON_RELOAD,
      onClick: () => {
        actualizarTabla();
      },
    },
    // {
    //   ...IconHelper.ICON_BS_FILTER,
    //   text: "Limpiar Filtro",
    //   onClick: () => {
    //     limpiarFiltro();
    //   },
    // },
  ];
  const _farItems: ICommandBarItemProps[] = [
    {
      ...IconHelper.ICON_EXCEL,
      onClick: () => {
        openPanelReporteTelerik();
      },
    },
    {
      ...IconHelper.ICON_FILTER,
      onClick: () => openPanelFilter(),
      text: "Buscar"
    },
  ];
  const _getPageSize = (value: number) => { };

  return (
    <div>
      <div className="ms-Grid-row" style={{ marginTop: "10px" }}>
        <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12">
          <CabeceraTable
            SubTitulo="Revisar Histórico de IPERCs de Equipo Trabajo"
            Titulo="Historial de IPERCs"
            placeholder="Buscar operador..."
            componentRef={searchBoxRefTable}
            onKeyUp={_onkeyUpSearchTable}
          />
        </div>
      </div>
      <br />
      <TableBase
        leftBar={_CommandLeftItems}
        rigthBar={_farItems}
        data={dataTable}
        column={_columns}
        isLoading={isLoading}
        getPageSize={_getPageSize}
        layout={DetailsListLayoutMode.justified}
      />
      <PanelSupervisorHistorialFiltro
        isOpen={isOpenPanelFilter}
        onDismiss={dismissPanelFilter}
        fechasFilter={filterFechas}
        filter={filter}
        limpiarFiltro={limpiarFiltro}
        onChangeChoiceGroup={_onChangeChoiceGroup}
        onChangeComboBox={onChangeComboBox}
        onSelectDate={_onSelectDate}
      />
      <PanelReporteTelerikSupervisorIperc
        isOpen={isOpenPanelReporteTelerik}
        onDismiss={dismissPanelReporteTelerik}
      />
    </div>
  );
};
